// extracted by mini-css-extract-plugin
export default {"container":"Container_container__5bjn1","inner":"Container_inner__lgKCx"};